import { render, staticRenderFns } from "./LembreteAtend.vue?vue&type=template&id=90a38fc4&"
import script from "./LembreteAtend.vue?vue&type=script&lang=js&"
export * from "./LembreteAtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports